import { FontOption } from '@wix/document-services-types';
import { PrivateAPINamespace } from '../PrivateAPINamespace';

export class InfoNamespace extends PrivateAPINamespace {
  static readonly namespace = 'info';

  public getMetaSiteId() {
    return this.ps.ds.generalInfo.getMetaSiteId();
  }

  public getUser() {
    return this.ps.ds.generalInfo.getUserInfo().userId;
  }

  public getEditorSessionId() {
    return this.ps.hostAPI.editor.info.getEditorSessionId();
  }

  public getAppInstance(appDefinitionId: string) {
    return this.ps.ds.platform.getAppDataByAppDefId(appDefinitionId)?.instance;
  }

  public getLanguageCode() {
    return this.ps.ds.generalInfo.getLanguage();
  }

  public getLocales() {
    return this.ps.ds.locales?.list?.() ?? [];
  }

  public getViewMode() {
    return this.ps.ds.viewMode.get();
  }

  public getEditorType() {
    // @ts-expect-error
    return window?.commonConfig?.brand;
  }

  public getSiteDirection() {
    return this.ps.ds.accessibility.getSiteDirection();
  }

  public siteHasCustomClasses() {
    const MASTER_PAGE_ID = 'masterPage';
    const CUSTOM_CSS_APP_ID = '081cfa21-cdf6-4f50-9a1b-0f3722acfd8b';

    return this.ps.ds.platform.pageHasPlatformApp(
      MASTER_PAGE_ID,
      CUSTOM_CSS_APP_ID,
    );
  }

  public getThemeCustomProperties(filter?: { keys: string[] }) {
    return this.ps.manifestServicesHost
      .getComponentsService()
      .theme.getThemeCustomProperties(filter);
  }

  public getSiteFonts(_filter?: { keys: string[] }) {
    type ReducedFont = Pick<
      FontOption['fonts'][number],
      'displayName' | 'characterSets' | 'fontFamily' | 'cssFontFamily'
    > & { style: { weight: number; style: string }[] }; // need to update dm type to include the style object

    const out: Record<string, ReducedFont> = {};

    const fontGroups = this.ps.ds.fonts.getSiteFontsOptions();
    for (const fontGroup of fontGroups) {
      for (const font of fontGroup.fonts) {
        if (
          _filter?.keys?.length &&
          !_filter?.keys?.includes(font.fontFamily)
        ) {
          continue;
        }

        const reducedFont: ReducedFont = {
          displayName: font.displayName,
          characterSets: font.characterSets,
          fontFamily: font.fontFamily,
          cssFontFamily: font.cssFontFamily,
          // @ts-expect-error - need to update dm type to include the style object
          style: font.style as unknown as { weight: number; style: string }[],
        };
        out[font.fontFamily] = reducedFont;
      }
    }

    return out as Record<string, object>;
  }

  public getFontFamilyDisplayName(fontFamily: string): string | undefined {
    return this.ps.hostAPI.editor.getFontFamilyDisplayName(fontFamily);
  }
}
